import React from 'react';
import TeamDetail from '../teamDetail';
import Typo from '../typo';

const Fixture = ({ match }) => {
  const { teamA, teamB } = match;

  return (
    <>
      <div className='si-fixture'>
        {
          <div className='si-fixture__teamA'>
            <TeamDetail teamName={teamA.name} teamFlag={teamA.id} />
          </div>
        }
        <Typo transKey={'fixture_vs'} component='span' className='si-fixture__versus'>
        </Typo>
        <div className='si-fixture__teamB'>
          <TeamDetail teamName={teamB.name} teamFlag={teamB.id} />
        </div>
      </div>
    </>
  );
};

export default Fixture;
